import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { fieldsForm, schema } from './fields'
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import useForm from 'hooks/useForm';
import { LOAD_PERSONAL_INFO, LOAD_PERSONAL_INFO_REPLY, LOAD_DEGREE_OPTIONS } from "schemas/register";
import Preference from './Preference';
import './style.scss'

export default function ProgramSelection({ labels, next }) {
  const {
    formik,
    renderElementsForm,
    renderElement
  } = useForm({
    fieldsForm,
    schema,
    loadMutation: LOAD_PERSONAL_INFO,
    loadMutationReply: LOAD_PERSONAL_INFO_REPLY,
    // saveMutation: SAVE_USER_INFO,
  })

  const formElements = useMemo(() => renderElementsForm(), [fieldsForm]);
  const [loadDegreeOptions, { loading, data: loadDegreeOptionsData, error }] = useLazyQuery(LOAD_DEGREE_OPTIONS);
  const [degreeOptions, setDegreeOptions] = useState([]);

  useEffect(() => {
    async function fetchData() {
      loadDegreeOptions();
    }
    fetchData();
  }, []);


  useEffect(() => {
    if (loadDegreeOptionsData) {
      setDegreeOptions(loadDegreeOptionsData.loadDegreeOptions)
    }
  }, [loadDegreeOptionsData])

  function renderOptions() {
    return <React.Fragment>
      {degreeOptions.map(o =>
        <option>{Object.values(o)}</option>
      )}
    </React.Fragment>
  }

  return (
    <div className="programSelection">
      <h3>בחירת תכנית</h3>
      <Form onSubmit={formik.handleSubmit}>
        {renderElement(formElements[0], labels, renderOptions())}
        {renderElement(formElements[1], labels, renderOptions())}
        {formik.values.preferences.map((pref, index) => (
          <Preference element={formElements[2]} renderElement={renderElement} formik={formik} key={index} index={index} />
        ))}
        <Button aria-label="המשך" type="submit">המשך</Button>
      </Form>
    </div>
  )
}